(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flemar-donation-bar"]) return;
  try {
    
  (function () {
    if (window.FlemarDonation) return;

    var API_STATS = 'https://api.flemar.com/socialStats.json'; // {countdown, totalsent, totalwaiting} — the numbers
    var API_MSG = 'https://api.flemar.com/social.json';         // localized sentence, fallback only
    var CACHE_KEY = 'flemarDonation';
    var CACHE_TTL = 5 * 60 * 1000;
    var PAIR_TYPE = 'slippers';
    // product ids of the pairs, emitted by the strip from the slippers collection (product type/handle are translated per locale)
    function pairIds() {
      var el = document.querySelector('[data-pair-ids]');
      var ids = el ? el.getAttribute('data-pair-ids').split(',').filter(Boolean).map(Number) : [];
      return ids;
    }
    var state = { remaining: null, totalSent: null, cartPairs: null };

    function all() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-flemar-donation]'));
    }

    function strings(el) {
      if (el._fdI18n) return el._fdI18n;
      var s = el.querySelector('[data-fd-i18n]');
      try { el._fdI18n = s ? JSON.parse(s.textContent) : {}; } catch (e) { el._fdI18n = {}; }
      return el._fdI18n;
    }

    var decoder = document.createElement('textarea');
    function fill(tpl, vars) {
      // the t filter HTML-escapes strings it interpolates into (&#39; for apostrophes): decode for textContent
      decoder.innerHTML = String(tpl || '').split('__N__').join(vars.n).split('__SOLD__').join(vars.sold);
      return decoder.value;
    }

    function render(el) {
      var t = strings(el);
      var cycle = parseInt(el.getAttribute('data-cycle'), 10) || 15;
      var cart = state.cartPairs === null ? (parseInt(el.getAttribute('data-cart-pairs'), 10) || 0) : state.cartPairs;
      var known = state.remaining !== null;
      var sold = known ? Math.max(0, Math.min(cycle, cycle - state.remaining)) : 0;
      var total = sold + cart;
      // Overflow: a basket bigger than what is left fills the counter (wraps >= 1) and starts the
      // next cycle at `rest`. We show the full counter (the satisfying state) and the sentence says
      // how many pairs are given away and where the counter restarts.
      var wraps = known ? Math.floor(total / cycle) : 0;
      var rest = known ? total % cycle : 0;
      var shown = Math.min(cycle, total);
      var n = cycle - shown;
      var complete = known && total >= cycle;
      var vars = { n: n, sold: shown };

      el.setAttribute('data-fd-state', known ? (complete ? 'complete' : 'live') : 'static');
      el.setAttribute('data-fd-cart', cart > 0 ? 'true' : 'false');

      var count = el.querySelector('[data-fd-count]');
      if (count) count.textContent = known ? shown + '/' + cycle : '';
      var big = el.querySelector('[data-fd-big]');
      if (big) big.textContent = known ? String(shown) : '';

      var status = el.querySelector('[data-fd-status]');
      if (status) {
        var msg;
        if (!known) msg = t.static;
        else if (cart > 0 && wraps >= 1 && (rest > 0 || wraps > 1)) {
          // the basket goes past the end: N pairs given away, counter restarts at rest/cycle
          msg = wraps === 1 ? t.with_cart_wrap_one : t.with_cart_wrap_other;
          vars = { n: wraps, sold: rest };
        }
        else if (cart > 0) msg = complete ? t.with_cart_complete : (n === 1 ? t.with_cart_one : t.with_cart_other);
        else msg = complete ? t.complete : (n === 1 ? t.remaining_one : t.remaining_other);
        status.textContent = fill(msg, vars);
      }

      var fills = el.querySelectorAll('[data-fd-fill]');
      for (var f = 0; f < fills.length; f++) fills[f].style.width = (known ? (shown / cycle) * 100 : 0) + '%';

      var totalEl = el.querySelector('[data-fd-total]');
      if (totalEl && state.totalSent !== null && t.offered_total) {
        totalEl.textContent = fill(t.offered_total, { n: state.totalSent, sold: shown });
        totalEl.removeAttribute('hidden');
      }

      var pips = el.querySelector('[data-fd-pips]');
      if (pips) {
        var boxes = pips.querySelectorAll('[data-fd-pip]');
        for (var i = 0; i < boxes.length; i++) {
          var idx = i + 1;
          boxes[i].classList.toggle('is-filled', known && idx <= sold);
          boxes[i].classList.toggle('is-mine', known && idx > sold && idx <= shown);
          boxes[i].classList.toggle('is-lit', complete);
        }
        pips.setAttribute('aria-label', known ? fill(t.sold, vars) : t.static);
      }
    }

    function renderAll() { all().forEach(render); }

    function useStats(remaining, totalSent) {
      state.remaining = remaining;
      if (typeof totalSent === 'number') state.totalSent = totalSent;
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), remaining: remaining, totalSent: state.totalSent })); } catch (e) {}
      renderAll();
    }

    function getJson(url) {
      return fetch(url, { mode: 'cors', cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; });
    }

    function load() {
      var cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(CACHE_KEY)); } catch (e) {}
      if (cached && typeof cached.remaining === 'number' && Date.now() - cached.t < CACHE_TTL) {
        state.remaining = cached.remaining;
        if (typeof cached.totalSent === 'number') state.totalSent = cached.totalSent;
        renderAll();
        return;
      }
      if (!window.fetch) return;
      // 1. the numbers (socialStats.json); 2. if unavailable, the number inside the sentence (social.json)
      getJson(API_STATS)
        .then(function (data) {
          if (data && typeof data.countdown === 'number' && data.countdown >= 0) {
            useStats(data.countdown, typeof data.totalsent === 'number' && data.totalsent > 0 ? data.totalsent : null);
            return;
          }
          return getJson(API_MSG).then(function (d2) {
            var msg = d2 && d2.msg && (d2.msg.fr || d2.msg.en || d2.msg.nl);
            var m = msg && String(msg).match(/\d+/);
            if (m) useStats(parseInt(m[0], 10), null);
          });
        })
        .catch(function () { /* unreachable (CORS off-domain, offline): the static rule stays */ });
    }

    function injectDrawer() {
      var footer = document.querySelector('#CartDrawer .drawer__footer');
      var tpl = document.getElementById('FlemarDonationDrawerTpl');
      if (!footer || !tpl || !('content' in tpl) || footer.querySelector('[data-flemar-donation]')) return;
      footer.insertBefore(tpl.content.cloneNode(true), footer.firstChild);
    }

    function countPairs(cart) {
      if (!cart || !cart.items) return null;
      var ids = pairIds();
      return cart.items.reduce(function (sum, item) {
        var isPair = ids.length ? ids.indexOf(item.product_id) !== -1 : item.product_type === PAIR_TYPE;
        return sum + (isPair ? (item.quantity || 0) : 0);
      }, 0);
    }

    // quantity changes: Streamline dispatches cart:updated with the cart payload
    document.addEventListener('cart:updated', function (e) {
      var pairs = countPairs(e.detail && e.detail.cart);
      if (pairs === null) return;
      state.cartPairs = pairs;
      renderAll();
    });

    // add to cart: Streamline only dispatches ajaxProduct:added (no cart payload), so re-read the cart
    document.addEventListener('ajaxProduct:added', function () {
      if (!window.fetch) return;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          var pairs = countPairs(cart);
          if (pairs === null) return;
          state.cartPairs = pairs;
          renderAll();
        })
        .catch(function () {});
    });

    document.addEventListener('shopify:section:load', function () {
      injectDrawer();
      renderAll();
    });

    function init() {
      injectDrawer();
      renderAll();
      load();
    }

    window.FlemarDonation = {
      refresh: renderAll,
      // QA helpers: simulate a basket of n pairs / a live countdown without touching the real cart or API
      setCartPairs: function (n) { state.cartPairs = Math.max(0, parseInt(n, 10) || 0); renderAll(); },
      setRemaining: function (n) { state.remaining = Math.max(0, parseInt(n, 10) || 0); renderAll(); }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flemar-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-flemar-sticky-atc]');
    if (!bar) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var real = form && form.querySelector('[data-add-to-cart]');
    if (!form || !real || !('IntersectionObserver' in window)) return;

    var btn = bar.querySelector('[data-flemar-sticky-btn]');
    var txt = bar.querySelector('[data-flemar-sticky-text]');
    var price = bar.querySelector('[data-flemar-sticky-price]');
    var realTxt = real.querySelector('[data-add-to-cart-text]');
    var realPrice = document.querySelector('.product__price [data-product-price], .product__price');

    // the theme's own option selects (one per option, data-index="option1"...), and ours
    // Streamline attaches them to the form via form="<id>", not as descendants
    var realSelects = [].slice.call(document.querySelectorAll('select[data-variant-input][form="' + form.id + '"]'));
    if (!realSelects.length) realSelects = [].slice.call(form.querySelectorAll('select[data-variant-input]'));
    if (!realSelects.length) realSelects = [].slice.call(document.querySelectorAll('select[data-variant-input]'));
    // 2026-09-26: the button picker renders a fieldset of radios per option instead of a select
    var realGroups = [].slice.call(document.querySelectorAll('.product-section .variant-input-wrap[data-index]'));
    var barSelects = [].slice.call(bar.querySelectorAll('[data-flemar-sticky-select]'));
    function realFor(sel) {
      var idx = sel.getAttribute('data-index');
      for (var i = 0; i < realSelects.length; i++) {
        if (realSelects[i].getAttribute('data-index') === idx) return realSelects[i];
      }
      for (var g = 0; g < realGroups.length; g++) {
        if (realGroups[g].getAttribute('data-index') === idx) return realGroups[g];
      }
      return realSelects[barSelects.indexOf(sel)] || null;
    }
    function isGroup(r) { return r && r.tagName === 'FIELDSET'; }
    function groupRadios(r) { return [].slice.call(r.querySelectorAll('input[type="radio"]')); }
    function groupValue(r) {
      var c = groupRadios(r).filter(function (x) { return x.checked; })[0];
      return c ? c.value : '';
    }
    function ensurePlaceholder(sel) {
      var ph = sel.querySelector('option[value=""]');
      if (!ph) {
        ph = document.createElement('option');
        ph.value = '';
        ph.disabled = true;
        ph.textContent = (bar.getAttribute('data-size-placeholder') || 'Votre taille');
        sel.insertBefore(ph, sel.firstChild);
      }
      return ph;
    }

    function sync() {
      if (realTxt) txt.textContent = realTxt.textContent.trim();
      btn.disabled = real.disabled;
      if (realPrice) price.textContent = realPrice.textContent.trim();
      barSelects.forEach(function (sel) {
        var r = realFor(sel);
        if (!r) return;
        if (isGroup(r)) {
          var v = groupValue(r);
          if (!v) { ensurePlaceholder(sel).selected = true; sel.value = ''; } else { sel.value = v; }
          var radios = groupRadios(r);
          for (var i = 0; i < sel.options.length; i++) {
            var rr = null;
            for (var j = 0; j < radios.length; j++) if (radios[j].value === sel.options[i].value) rr = radios[j];
            if (sel.options[i].value !== '') sel.options[i].disabled = rr ? rr.classList.contains('disabled') : false;
          }
          return;
        }
        if (!r.value) { ensurePlaceholder(sel).selected = true; sel.value = ''; } else { sel.value = r.value; }
        for (var i2 = 0; i2 < sel.options.length; i2++) {
          var ro = null;
          for (var j2 = 0; j2 < r.options.length; j2++) if (r.options[j2].value === sel.options[i2].value) ro = r.options[j2];
          if (sel.options[i2].value !== '') sel.options[i2].disabled = ro ? ro.disabled : false;
        }
      });
    }

    // 2026-09-26: while the bar sits at the top (under 1100 px) and the theme's header is fixed
    // (tablets and narrow windows; phones hide the header on product pages), start the bar just
    // under the header instead of behind it.
    var header = document.querySelector('.site-header');
    var tabletBand = window.matchMedia ? window.matchMedia('(min-width: 769px) and (max-width: 1099px)') : null;
    function place() {
      var inBand = tabletBand && tabletBand.matches;
      var fixedHeader = header && getComputedStyle(header).position === 'fixed';
      bar.style.top = (inBand && fixedHeader) ? Math.round(header.getBoundingClientRect().height) + 'px' : '';
    }
    window.addEventListener('resize', place);

    function show(on) {
      if (on) place();
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) sync();
    }

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // visible only once the real button has scrolled above the viewport
      show(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(real);

    // size chosen in the bar -> push it into the theme's select so the theme does its usual work
    barSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var r = realFor(sel);
        if (!r || !sel.value) return;
        if (isGroup(r)) {
          var radio = groupRadios(r).filter(function (x) { return x.value === sel.value; })[0];
          if (!radio) return;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          r.value = sel.value;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
        setTimeout(sync, 50);
      });
    });

    btn.addEventListener('click', function () {
      if (real.disabled) return;
      real.click();
    });

    // keep text/price/size in step with changes made in the page while the bar is visible
    document.addEventListener('change', function (evt) {
      if (bar.contains(evt.target)) return;
      if (bar.classList.contains('is-visible')) setTimeout(sync, 50);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
